import React from 'react'

import { Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import { faCopy } from '@fortawesome/pro-solid-svg-icons'

import ClickableIcon from '../antd/Buttons/ClickableIcon'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const Mailing = ({ email }) => {
  const t = useSelector(selectTranslate)

  return (
    <div className='flex-row ai-ctr'>
      <Tooltip title={t('mailing_link.title')}>
        <a href={'mailto:' + email}>
          {email}
        </a>
      </Tooltip>
      <div className='ml-4'>
        <ClickableIcon icon={faCopy} title={t('mailing_link.copy_into_clipboard')} onClick={() => navigator.clipboard.writeText(email)} />
      </div>
    </div>
  )
}

export default Mailing
